import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { DropDownModel } from '../../../domain/model/common/dropDownModel';

@Component({
  selector: 'app-myprofile',
  templateUrl: './myprofile.component.html',
  styleUrl: './myprofile.component.css'
})
export class MyprofileComponent {

  constructor(private _formBuilder: FormBuilder) {}
  states: DropDownModel[] = [];
  showTaxRepresentativeForm : boolean = false;
  secondFormGroup = this._formBuilder.group({
    firstName: ['', Validators.required, Validators.maxLength(200)],
    lastName: ['', Validators.required],
    email: ['',Validators.required, Validators.email],
    phoneNumber: ['', Validators.required],
    password: ['', Validators.required],
    confirmPassword: ['', Validators.required],
    address1:['', Validators.nullValidator ],
    address2:['',],
    city:[''],
    state:['', ],
    zipCode:['', [Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/)]],
    internationalAddressName:['', ],
    internationalPoBox:['', ],
    internationalCityProvinceState:['', ],
    internationalCountry:['', ],
    note:[''],
    firstNameTax: [''],
    lastNameTax: [''],
    
    emailTax: ['', this.showTaxRepresentativeForm ? Validators.email:Validators.nullValidator],
    phoneNumberTax: [''],
    cityTax:[''],
    stateTax:[''],
    zipCodeTax:['' ],
  });
  showAndHideTaxForm(show :boolean){
    this.showTaxRepresentativeForm = show
 
    if(show){
      this.secondFormGroup.get('emailTax')?.setValidators(Validators.email);
    }else{
      this.secondFormGroup.get('emailTax')?.clearValidators();
    }
    this.secondFormGroup.get('emailTax')?.updateValueAndValidity();
  }
}
